import type { IRecord } from '@platform/core/types';
import type { IAreaModule } from './IAreaModule';
import type { IAreaStats } from './IAreaStats';

const DAY = 86400000;
const TOP = 8;

const dueOf = (r: IRecord): string => (typeof r.values['due'] === 'string' ? r.values['due'].slice(0, 10) : '');
const assigneeOf = (r: IRecord): string | null => {
  const a = r.values['assignee'];
  return a && typeof a === 'object' && !Array.isArray(a) ? a.id : null;
};
const newest = (a: IRecord, b: IRecord) => Date.parse(b.updatedAt) - Date.parse(a.updatedAt);
const byDue = (a: IRecord, b: IRecord) => dueOf(a).localeCompare(dueOf(b));

/**
 * Огляд напряму (чиста функція, прототип v4): записи головних таблиць модулів напряму; «записи» — лічильники каталогу; термін за 7 днів —
 * від сьогодні до `in7`; виконано — закриті записи, оновлені за 30 днів до `now`; прострочені, далі ті, що на тиждень, — за терміном.
 */
export function areaStats(records: readonly IRecord[], modules: readonly IAreaModule[], meId: string | undefined, today: string, in7: string, now: number): IAreaStats {
  const open = records.filter((r) => !r.isClosed);
  const late = open.filter((r) => !!dueOf(r) && dueOf(r) < today);
  const soon = open.filter((r) => !!dueOf(r) && dueOf(r) >= today && dueOf(r) <= in7);
  const mine = open.filter((r) => !!meId && assigneeOf(r) === meId);
  const openOf = (key: string) => open.filter((r) => r.module === key);
  const max = Math.max(1, ...modules.map((m) => openOf(m.key).length));
  return {
    records: modules.reduce((sum, m) => sum + m.total, 0),
    open: open.length,
    overdue: late.length,
    soon: soon.length,
    mine: mine.length,
    done30: records.filter((r) => r.isClosed && Date.parse(r.updatedAt) >= now - 30 * DAY).length,
    modules: modules.map((m) => {
      const o = openOf(m.key);
      return { ...m, open: o.length, overdue: o.filter((r) => late.includes(r)).length, width: Math.round((o.length / max) * 100) };
    }),
    overdueAndSoon: [...[...late].sort(byDue), ...[...soon].sort(byDue)].slice(0, TOP),
    assigned: [...mine].sort(newest).slice(0, TOP),
    recent: [...records].sort(newest).slice(0, TOP),
  };
}
